// app/translate/translate.pipe.ts

import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../translate'; // our translate service

@Pipe({
    name: 'translate',
    pure: false // impure pipe, update value when we change language
})

export class TranslatePipe implements PipeTransform {

	constructor(private _translate: TranslateService) { }

	transform(value: string, args: string | string[]): any {
		if (!value) return;
		
		return this._translate.instant(value, args);
	}
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/translate/translate.pipe.ts